"use client"

export const TamdaExpressProductListSkeleton = () => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 sm:gap-4">
      {Array.from({ length: 8 }).map((_, index) => (
        <div key={index} className="flex flex-col rounded-lg p-5 bg-white border border-gray-200 animate-pulse">
          <div className="relative h-[148px] mb-4 bg-gray-200 rounded-lg" />
          <div className="h-4 bg-gray-200 rounded mb-2" />
          <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
          <div className="flex justify-between items-center mb-2">
            <div className="h-3 bg-gray-200 rounded w-20" />
            <div className="h-3 bg-gray-200 rounded w-16" />
          </div>
          <div className="flex justify-between items-center mb-4">
            <div className="h-4 bg-gray-200 rounded w-16" />
            <div className="h-3 bg-gray-200 rounded w-12" />
          </div>
          <div className="h-10 bg-gray-200 rounded" />
        </div>
      ))}
    </div>
  )
}
